import React, { useEffect } from 'react';
import { useParams, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LangWrapper = () => {
  // @ts-ignore
  const { i18n } = useTranslation();

  const { lang } = useParams<{ lang: string }>();

  useEffect(() => {
    const supportedLangs = ['sc', 'tc', 'en'];
  
    if (!lang || !supportedLangs.includes(lang)) {
      const targetLang = i18n.language || 'en';
      window.location.replace(`/${targetLang}`);
      return;
    }
  
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang]);

  return <Outlet />;
};

export default LangWrapper;